export const socialSkillsTraining = {
    'meta': {
        'title': 'Trening Umiejętności Społecznych #cityLocativeIn# • Centrum Psychoterapii COLLIGO',
        'description': 'Trening Umiejętności Społecznych #cityLocativeIn# to cykliczne zajęcia grupowe o określonej i stałej strukturze, które są ukierunkowane na rozwijanie kompetencji społecznych, komunikacyjnych i emocjonalnych.'
    },
    'availability': [
        'torun'
    ],
    'url': {
        'address': '#cityIdUrl#/uslugi/trening-umiejetnosci-spolecznych/',
        'title': 'Trening Umiejętności Społecznych #cityLocativeIn#',
        'name': 'Trening Umiejętności Społecznych #cityLocativeIn#',
        'heading': 'Trening Umiejętności Społecznych #cityLocativeIn#',
        'fullName': 'Trening Umiejętności Społecznych'
    },
    'image': {
        'url': '/images/services/trening-umiejetnosci-spolecznych.webp',
        'width': 840,
        'height': 321,
        'alt': 'Trening Umiejętności Społecznych #cityLocativeIn#'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/trening-umiejetnosci-spolecznych.webp',
            'width': 840,
            'height': 321,
            'alt': 'Trening Umiejętności Społecznych #cityLocativeIn#'
        }
    }
}